import { useCallback } from 'react'

import { FilterFunc, FilterFuncMap } from './types/unitFilteringTypes'

export enum SiteViewFilterKey {
  Groupings = 'SiteViewSidebarGroupingsFilters',
  Table = 'SiteViewSidebarTable',
  AssetTracker = 'SiteViewAssetTracker',
  HealthCondition = 'SiteViewHealthConditionFilter',
}

export function useGetSidebarComponentFilterFns(
  setUnitFilterFuncs: (
    value: ((prevState: FilterFuncMap) => FilterFuncMap) | FilterFuncMap
  ) => void
) {
  const setShouldFilterSidebarGroupingsFn = useCallback(
    (newFunc: FilterFunc) => {
      setUnitFilterFuncs((prev) => ({
        ...prev,
        [SiteViewFilterKey.Groupings]: {
          filterFunc: newFunc,
        },
      }))
    },
    [setUnitFilterFuncs]
  )
  const setShouldFilterSidebarTableFn = useCallback(
    (newFunc: FilterFunc) => {
      setUnitFilterFuncs((prev) => ({
        ...prev,
        [SiteViewFilterKey.Table]: {
          filterFunc: newFunc,
          dontApplyToSidebar: true,
        },
      }))
    },
    [setUnitFilterFuncs]
  )

  const setShouldFilterSidebarAssetTrackerFn = useCallback(
    (newFunc: FilterFunc) => {
      setUnitFilterFuncs((prev) => ({
        ...prev,
        [SiteViewFilterKey.AssetTracker]: {
          filterFunc: newFunc,
        },
      }))
    },
    [setUnitFilterFuncs]
  )

  const setShouldFilterHealthConditionFn = useCallback(
    (newFunc: FilterFunc) => {
      setUnitFilterFuncs((prev) => ({
        ...prev,
        [SiteViewFilterKey.HealthCondition]: {
          filterFunc: newFunc,
        },
      }))
    },
    [setUnitFilterFuncs]
  )

  return {
    setShouldFilterSidebarGroupingsFn,
    setShouldFilterSidebarTableFn,
    setShouldFilterSidebarAssetTrackerFn,
    setShouldFilterHealthConditionFn,
  }
}
